export class SubTypeJobs {
  deleteAt = null;
  _id = null;
  name = null;
  status = null;
  typeJob = null;
  __v = null;
}

export class TypeJob {
  subTypeJobs = [new SubTypeJobs()];
  deleteAt = null;
  _id = null;
  name = null;
  status = null;
  __v = null;
}
